/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Nutrition_GuessedInputs */

const en_nutrition_guessed = /** @type {(inputs: Nutrition_GuessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weight estimated from pieces or spoons: ${i?.names}.`)
};

const de_nutrition_guessed = /** @type {(inputs: Nutrition_GuessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht aus Stück- oder Löffelangaben geschätzt: ${i?.names}.`)
};

/**
* | output |
* | --- |
* | "Weight estimated from pieces or spoons: {names}." |
*
* @param {Nutrition_GuessedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_guessed = /** @type {((inputs: Nutrition_GuessedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_GuessedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_guessed(inputs)
	return en_nutrition_guessed(inputs)
});